import { isString } from 'lodash';

// older categories won't have headerTitle property so we take label
export const getHeaderTitle = (category) =>
  isString(category.headerTitle) ? category.headerTitle : category.label;

export const getSubcategories = (allCategories, categoryId) =>
  allCategories.filter((c) => c.parentId === categoryId);
